import { FunctionalInterfaceInstanceParams } from '@/backend/access/functionalInterfaceInstance/types';

export class FunctionalInterfaceInstance {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  orgId: string;
  versionId: string;

  constructor(params: FunctionalInterfaceInstanceParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.orgId = params.orgId;
    this.versionId = params.versionId;
  }
}
